import React, { PureComponent } from "react";
import { Wrapper, Copy } from "app/NativeComponents/common";
import { connect } from "react-redux";

import { EmailBadge } from "./ContactabilityColumnItem";

class EmailAddressColumnItem extends PureComponent {

  state = {
    showTooltip: false,
    tooltipAnchorRect: null
  };

  handleTooltipEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    this.setState({
      showTooltip: true,
      tooltipAnchorRect: rect
    });
  };

  handleTooltipLeave = () => {
    this.setState({
      showTooltip: false,
      tooltipAnchorRect: null
    });
  };

  renderContactability() {
    const { property, dark_mode } = this.props;

    const contactability = property?.contactability;
    if (!contactability) return <Copy>--</Copy>;

    const emailCount = contactability.email_count || 0;

    if (emailCount === 0) {
      return <Copy>--</Copy>;
    }

    return (
      <EmailBadge
        emailCount={emailCount}
        dark_mode={dark_mode}
        showTooltip={this.state.showTooltip}
        onTooltipEnter={this.handleTooltipEnter}
        onTooltipLeave={this.handleTooltipLeave}
        anchorRect={this.state.tooltipAnchorRect}
      />
    );
  }

  render() {
    const { row_height } = this.props;

    return (
      <Wrapper
        className="deal-hover-preview"
        style={{
          padding: 10,
          height: row_height,
          position: "relative"
        }}
      >
        <Wrapper
          style={{
            flex: 1,
            alignItems: "flex-start",
            justifyContent: "center"
          }}
        >
          {this.renderContactability()}
        </Wrapper>
      </Wrapper>
    );
  }
}

/* ---------------- REDUX CONNECT ---------------- */

const mapStateToProps = ({ settings }) => ({
  dark_mode: settings?.dark_mode
});

export default connect(mapStateToProps)(EmailAddressColumnItem);
